import React from "react";

import ReactModal from "react-modal";
import { useModal } from "react-modal-hook";

  function Card ({portfolio}){

    const [showModal, hideModal] = useModal(() => (
      <ReactModal isOpen>
            <div>
            <img src={require('../images/' + portfolio.img)} alt={portfolio.Title} />
              <div className="container">
                <h1 id="title">
                    {portfolio.Title}
                  </h1>
                  <p id="category">
                    Stack : {portfolio.Techno}
                  </p>
                <div>
                  <h2>{portfolio.Subtitle}</h2>
                  <p>{portfolio.Description}</p>
                  <a target='_blank' rel="noreferrer" href={portfolio.link}>Voir le Projet</a>
                </div>
              </div>
            </div>
        <span onClick={hideModal}>X</span>
      </ReactModal>
    ));
      return(

          <article onClick={showModal}>
            <img src={require('../images/' + portfolio.img)} alt={portfolio.Title}  />
            <div>
              <h2>
                  {portfolio.Title}
              </h2>
              <p>
                {portfolio.Techno}
              </p>
            </div>
          </article>
          
      );
  }

  export default Card;